import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SeatMgmtService {
  constructor(private http: HttpClient) {}

  getOfficeSeats(scopeID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/get-seats/${scopeID}`
    );
  }

  editSeat(seatID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/edit-seat/${seatID}`
    );
  }

  addSeat(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/add-seat`,
      data
    );
  }

  deleteSeat(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/delete_seat`,
      data
    );
  }

  bookOnbehalf(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/book-seat-for-employee`,
      data
    );
  }

  getSeatForBooking(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/get-seats-for-booking`,
      req
    );
  }
  empdropdown(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_employee`);
  }

  getDepartmentMaster(scopeID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/get_department_master/` + scopeID
    );
  }

  getDepartmentOccupancy(scopeID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/department_wise_occupancy/` + scopeID
    );
  }

  deleteDeptsMap(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/delete_department_master`,
      { id: data }
    );
  }

  addDept(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/add_dept`,
      data
    );
  }

  // department mapping

  getDeparmentMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/policy/seats/get_dept_master`,
      { params: param }
    );
  }

  deleteDepartment(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/delete_dept`,
      data
    );
  }

  addDepartMapping(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/seats/dept_scope_mapping_action`,
      data
    );
  }

  editDepartment(deptID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/edit_dept/${deptID}`
    );
  }

  getDepartments(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/get_scope_department`
    );
  }

  // Report

  seatTxnReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/seats/get_report_for_seat_master`
    );
  }

  deleteScopeMngr(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/policy/delete_scope_users`,
      data
    );
  }
  scopeStatus(): Observable<any>{
    return this.http.get<any>(
      `${environment.apiUrl}/policy/select_wrk_perm_rgn`);
    }

    

    addPantryMap(data): Observable<any> {
      return this.http.post<any[]>(
        `${environment.apiUrl}/policy/pantry/add_pantry_map`,
        data
      );
    }

    getPatryMappedMaster(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      
      return this.http.get<any[]>(
        `${environment.apiUrl}/policy/pantry/get_pantry_map`,{params:param}
      );
    }

    editPantry(id): Observable<any>{
      return this.http.get<any>(
        `${environment.apiUrl}/policy/pantry/edit_pantry/` + id);
      }

    deletePantryMap(delID): Observable<any> {
      return this.http.post<any[]>(
        `${environment.apiUrl}/policy/pantry/delete_pantry_map`,{pantry_id:delID});
    }

}
